var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12"},[_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('TabelObat')],1)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }